import React from "react";
import { RedirectToSignIn, SignUp } from "@clerk/clerk-react";
export default function SIgnupTest() {
  return (
    <div>
      <SignUp />
    </div>
  );
}
